


















import Vue, { PropType } from 'vue';
import { urlFor } from '@/config/sanity';
import VideoPublication from '@/models/videoPublication';
import VideoCard from './VideoCard.vue';

export default Vue.extend({
  name: 'VideoGalleryPanel',
  components: {
    VideoCard,
  },
  props: {
    headline: {
      type: String,
      required: true,
      default: () => 'Medieproduksjoner',
    },
    videos: {
      type: Array as PropType<Array<VideoPublication>>,
      required: true,
    },
    headlineSize: String,
    headlinePosition: String,
  },
  data() {
    return {
      promotedVideo: this.videos[0],
      standardVideos: this.videos.slice(1, this.videos.length),
    };
  },
  methods: {
    urlFor,
  },
});
